/**
 * 为页面权限控制的指令
 * v-auth="auth-code"
 */
import store from '../vuex/store'
export default {
	//绑定到元素的时候触发
	bind:function(el, binding, vnode) {
		let user = store.getters.auth_user;
		if(user.superMgr) {
			return;
		}
		let permsMap = store.getters.auth_perms;
		let expression = binding.value;
		if(expression && permsMap) {
			//隐藏该节点
			//去掉引号
			// expression = expression.replace(/\'/g,"");
			if(!permsMap[expression]) {
				el.style.display ='none';
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/directives/auth.js